import backendApi from '@italist/backend-api';
import * as Sentry from '@sentry/browser';
import { home } from '../helpers/routes';

// Actions
const API_GET = 'modules/api/API_GET';
const API_RESULT = 'modules/api/API_RESULT';

// Reducer
const reducer = (state = { status: '', message: '' }, { type, payload } = {}) => {
  switch (type) {
    case API_RESULT:
      return { ...state, ...payload };
    default:
      return state;
  }
};

// Action Creators
const apiResult = payload => ({ type: API_RESULT, payload });

const apiGet = (url, req, res, params = {}, errorHandler) => (dispatch, getState) =>
  backendApi
    .get(url, params, req, res)
    .then(response => {
      const { path, hostname, originalUrl, query } = req;
      response.data.location = {
        path,
        hostname,
        originalUrl,
        query
      };
      dispatch(apiResult(response.data));
      if (response.data.auth && url.indexOf('api/authentication') > -1) {
        res.redirect(home);
      }
    })
    .catch(e => {
      Sentry.captureException(e);
      if (errorHandler) {
        errorHandler(e);
      } else if (!e.response) {
        res.sendStatus(500);
      } else if (e.response.status === 404) {
        const { countryCode } = getState();
        res.redirect(`/${countryCode}/not_found`);
      } else {
        res.sendStatus(e.response.status);
      }
    });

const apiDelete = (url, req, res, params = {}) => (dispatch, getState) =>
  backendApi
    .delete(url, params, req, res)
    .then(response => {
      const { path, hostname, originalUrl, query } = req;
      response.data.location = {
        path,
        hostname,
        originalUrl,
        query
      };
      dispatch(apiResult(response.data));
    })
    .catch(e => {
      Sentry.captureException(e);
      if (e.response.status) {
        const { countryCode } = getState();
        res.redirect(`/${countryCode}/not_found`);
      }
    });

export { reducer as default, apiGet, apiDelete, API_GET, API_RESULT };
